import * as React from "react";
import { useTranslation } from "react-i18next";
import { CompanyDetails } from "../../models/interfaces/profile-summary.interface";

type ProfileCompanyDetailsProps = {
  companyDetails: CompanyDetails;
};

const ProfileCompanyDetails = (props: ProfileCompanyDetailsProps) => {
  const { companyDetails } = props;
  const { t } = useTranslation();

  return (
    <div className="text-sm">
      <div className="my-1">
        <span className="font-semibold text-gray-700">
          {t("profileSummary.label.company")}
        </span>
        <span className="mx-1">-</span>
        <span>{companyDetails?.company}</span>
      </div>
      <div className="my-1">
        <span className="font-semibold text-gray-700">
          {t("profileSummary.label.role")}
        </span>
        <span className="mx-1">-</span>
        <span>{companyDetails?.role}</span>
      </div>
    </div>
  );
};

export default ProfileCompanyDetails;
